import React, {useEffect, useState} from "react";
import PageName from "../../components/PageName";
import Card from "../../components/Base/Card";
import {FiX} from "react-icons/fi";
import Dropzone from "../../components/Base/Dropzone";
import { useForm } from "react-hook-form";
import SuccessModal from "../../components/SuccessModal";
import {sendFeedback, WhistleBlowing} from "../../redux/feedback/feedbackSlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import LoadingSpinner from "../../components/LoadingSpinner";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorViewer from "../../components/ErrorViewer";
import Required from "../../components/Required";
import {WhistleBlowingModeOfEngagement} from "../../constants";
import {getStates} from "../../redux/utils/utilsSlice";
import {CORGRequest} from "../../redux/selfService/selfServiceSlice";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const WhistleBlowingPage = () => {
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state) => state?.auth);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [modeOfEngagement, setModeOfEngagement] = useState(0);
  const { allStates } = useAppSelector((state) => state?.utils);

    const addFilesForUpload = (acceptedFiles: File[])=>{
      setUploadedFiles(prevFiles => [...prevFiles, ...acceptedFiles]);
    }

    const removeFile = (file: File)=> {
        setUploadedFiles(prevFiles =>
            prevFiles.filter(a=> a.name !== file.name))
    }


  useEffect(()=>{
    dispatch(getStates());
  }, [])

  useEffect(()=>{
    if(uploadedFiles.length > 0) {
      for(let i = 0; i < uploadedFiles.length; i++){
          // @ts-ignore
        setValue(`Evidence${i+1}`, uploadedFiles[i]);
      }
    } else {
        // setValue("Evidence1", null);
    }
   trigger("Evidence1")
  }, [uploadedFiles])

    const validationSchema = Yup.object().shape({
      modeOfEngagement: Yup.number().required("Please select one"),
      // phoneNumber: "",
      // email: "",
      // Address: "",
      phoneNumber: Yup
        .string()
        .when("modeOfEngagement", {
          is: (val:string)=>val==="0",
          then: ()=>Yup.string().required('Please enter your phone number'),
        }),
      email: Yup
        .string()
        .when("modeOfEngagement", {
          is: (val:string)=>val==="1",
          then: ()=>Yup.string().email("Not a valid email").required('Please enter your email'),
        }),
      address: Yup
        .string()
        .when("modeOfEngagement", {
          is: (val:string)=>(val==="2" || val==="3"),
          then: ()=>Yup.string().required('Please enter your address'),
        }),
      NameOfOfficer: Yup.string().required("Officer name is required"),
      LocationOfEvidence: Yup.string().required("Location is required"),
      NatureOfConduct: Yup.string().required("Nature of Conduct is required"),
      Remarks: Yup.string().required("Please add a remark"),
      Evidence1: Yup.mixed().test("required", "You need to upload at least one evidence", (file) => {
        // return file && file.size <-- you can use this if you don't want to allow empty files to be uploaded;
        if (file) return true;
        return false;
      })
      // Evidence1: Yup.mixed().test("required", "Please select attachment.", (file) => {
      //   if (file) return true;
      //   return false;
      // }),
      // Evidence1: Yup.mixed(),
      // .test("required", "Please select attachment.", function (file) {
      //   // console.log('XXXXXXXXXX',file);
        
      //   if (!file) {
      //     return false; // Validation fails when no file is selected
      //   }
      //   return true; // Validation passes when a file is selected
      // }),
      // Evidence1: Yup.mixed().test("required", "You need to upload at least one evidence", (file) => {
      //   // return file && file.size <-- u can use this if you don't want to allow empty files to be uploaded;
      //   if (file) return true;
      //   return false;
      // })
    });

  const defaultFormValues = {
          modeOfEngagement: 0,
          phoneNumber: "",
          email: "",
          address: "",
          NameOfOfficer: "",
          LocationOfEvidence: "",
          NatureOfConduct: "",
          Remarks: "",
          Evidence1: null,
          evidence2: null,
      };

    const {
        handleSubmit, reset, register, setValue, trigger,
        formState: {errors},
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {...defaultFormValues}
    });

  const onSubmit = async (values: any, e: any) => {
    e.preventDefault();
      let whistleBlowingFormData = new FormData();
      if(uploadedFiles.length<=0){
        alert("You must attach a file.");
        return;
      }
      whistleBlowingFormData.append("Evidence1", uploadedFiles[0]);
      if (uploadedFiles && uploadedFiles.length > 1){
          whistleBlowingFormData.append("Evidence2", uploadedFiles[1])
      };
      // @ts-ignore
      whistleBlowingFormData.append("modeOfEngagement", parseInt(values.modeOfEngagement, 10));
      if(values.modeOfEngagement==0){
          whistleBlowingFormData.append("phoneNumber", values.phoneNumber);
      }
      if(values.modeOfEngagement==1){
          whistleBlowingFormData.append("email", values.email);
      }
      if(values.modeOfEngagement==2 || values.modeOfEngagement == 3){
          whistleBlowingFormData.append("address", values.address);
      }
      whistleBlowingFormData.append("NameOfOfficer", values.NameOfOfficer);
      whistleBlowingFormData.append("LocationOfEvidence", values.LocationOfEvidence);
      whistleBlowingFormData.append("NatureOfConduct", values.NatureOfConduct);
      whistleBlowingFormData.append("Remarks", values.Remarks);

    dispatch(WhistleBlowing(whistleBlowingFormData)).then(feedbackResp=>{
      if (feedbackResp.type === "whistle/fulfilled" && feedbackResp.payload?.statusCode === "00") {
        resetAll()
      }
    })
  };

  const resetAll = ()=>{
      reset({...defaultFormValues})
      setUploadedFiles([])
  }

  return (
    <TimeOutActivityLayout>
    <div className="transaction-page">
      <PageName pageName={"Whistle Blowing"} />
        <div className="transaction">
          <Card className="transaction-card">
            <div className="h1 text-grayscaleBody">Whistle Blowing</div>
            <Card>
              <div className="section-card">
                <div>Information</div>
                <div className="pb-8">
                  <div className="form w-full">
                    <div className="form__row">
                      <div className="form__group">
                        <label htmlFor="mode-of-engagement" className="form__label">
                          Mode of Engagement <Required />
                        </label>
                        <select
                          id="mode-of-engagement"
                          className="form__input"
                          defaultValue=""
                          onChange={(e)=>{
                            const MoENumber = parseInt(e.target.value, 10);
                            setModeOfEngagement(MoENumber);
                            setValue("modeOfEngagement", MoENumber);
                          }}
                        >
                          {
                            WhistleBlowingModeOfEngagement.map((MoE, index)=>(
                              <option value={index} key={index}>{MoE}</option>
                            ))
                          }
                        </select>
                          {errors.modeOfEngagement && (
                              <ErrorViewer message={errors.modeOfEngagement.message as string} />
                          )}
                      </div>
                      {
                        modeOfEngagement === 0 &&
                        <div className="form__group">
                          <label htmlFor="phoneNumber" className="form__label">
                            Phone Number <Required/>
                          </label>
                          <input
                            id="phoneNumber"
                            placeholder="Your Phone Number"
                            type="tel"
                            className="form__input"
                            disabled={isLoading}
                            {...register("phoneNumber")}
                          />
                          {errors.phoneNumber && (
                            <ErrorViewer message={errors.phoneNumber.message as string}/>
                          )}
                        </div>
                      }
                      {
                        modeOfEngagement === 1 &&
                        <div className="form__group">
                            <label htmlFor="email" className="form__label">
                              Email <Required />
                            </label>
                            <input
                              id="email"
                              placeholder="Your email"
                              type="email"
                              className="form__input"
                              disabled={isLoading}
                              {...register("email")}
                            />
                            {errors.email && (
                              <ErrorViewer message={errors.email.message as string} />
                            )}
                          </div>
                      }
                      {
                        (modeOfEngagement === 3 || modeOfEngagement === 2) &&
                        <div className="form__group">
                            <label htmlFor="in-person" className="form__label">
                              Your Address <Required />
                            </label>
                            <input
                              id="in-person"
                              placeholder="Your address"
                              type="text"
                              className="form__input"
                              disabled={isLoading}
                              {...register("address")}
                            />
                            {errors.address && (
                              <ErrorViewer message={errors.address.message as string} />
                            )}
                          </div>
                      }
                    </div>
                    <div className="form__row">
                      <div className="form__group">
                        <label htmlFor="name-of-officer" className="form__label">
                          Name of Officer <Required />
                        </label>
                        <input
                          id="name-of-officer"
                          placeholder="Name of Officer"
                          type="text"
                          className="form__input"
                          disabled={isLoading}
                          {...register("NameOfOfficer")}
                        />
                          {errors.NameOfOfficer && (
                              <ErrorViewer message={errors.NameOfOfficer.message as string} />
                          )}
                      </div>
                      <div className="form__group">
                        <label htmlFor="LocationOfEvidence" className="form__label">
                          Location of Evidence <Required/>
                        </label>
                        <select id="LocationOfEvidence" defaultValue=""
                                className="form__select" {...register("LocationOfEvidence")}>
                          <option value="" disabled>Select Location</option>
                          {allStates && Object.keys(allStates).map((a, index) => (
                            <option value={a} key={index}>{allStates[a]}</option>
                          ))}
                        </select>
                        {errors.LocationOfEvidence && (
                          <ErrorViewer message={errors.LocationOfEvidence.message as string} />
                        )}
                      </div>
                    </div>
                    <div className="form__row">
                      <div className="form__group">
                        <label htmlFor="nature-of-conduct" className="form__label">
                          Nature of Conduct <Required />
                        </label>
                        <input
                          id="nature-of-conduct"
                          placeholder="Nature of Conduct"
                          type="text"
                          className="form__input"
                          disabled={isLoading}
                          {...register("NatureOfConduct")}
                        />
                        {errors.NatureOfConduct && (
                          <ErrorViewer message={errors.NatureOfConduct.message as string} />
                        )}
                      </div>
                    </div>
                    <div className="form__group">
                      <label htmlFor="Remarks" className="form__label">
                        Remarks <Required />
                      </label>
                      <textarea
                        id="Remarks"
                        rows={5}
                        className="form__input"
                        disabled={isLoading}
                        {...register("Remarks")}
                      />
                        {errors.Remarks && (
                            <ErrorViewer message={errors.Remarks.message as string} />
                        )}
                    </div>

                    <div className="form__group">
                      <ul className="my-3">
                        <label htmlFor="lastName" className="form__label">
                          Evidence
                          {errors.Evidence1 && (
                            <ErrorViewer message={errors.Evidence1.message as string} />
                          )}
                        </label>
                        {
                          uploadedFiles && uploadedFiles.map((file, index)=>(
                            <li className="flex items-center" key={index}>
                              <div>{file.name}</div>
                              <button className="btn btn-icon ml-4" onClick={()=>removeFile(file)}>
                                <FiX />
                              </button>
                            </li>
                          ))
                        }
                      </ul>
                      {
                        (!uploadedFiles || (uploadedFiles && uploadedFiles.length < 2)) &&
                        <>
                          {/* @ts-ignore */}
                          <Dropzone onDrop={addFilesForUpload} accept={"image/jpeg,image/gif,image/png,application/pdf"} />
                        </>
                      }
                      </div>
                  <div className="flex justify-end">
                      <button className="btn btn-outline mr-4" onClick={resetAll}>Reset</button>
                      <button
                        className="btn btn-primary"
                        onClick={handleSubmit(onSubmit)}
                        disabled={isLoading}
                      >
                        {isLoading ? <LoadingSpinner /> : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Card>
        </div>
    </div>
    </TimeOutActivityLayout>
  );
};
export default WhistleBlowingPage;
